export default {
    beforeMount(el, binding) {
        const handler = (event) => {
            // Skip if event has been handled already
            if (event._clickOutsideHandled) return;

            // Check if clicked element is the target or inside target
            if (el === event.target || el.contains(event.target)) {
                return;
            }

            // Mark as handled to prevent duplicate handling
            event._clickOutsideHandled = true;

            // Fire the provided method
            binding.value(event);
        };

        // Save handler reference for removal later
        el.__clickOutsideHandler__ = handler;

        // Add event listener with capture to ensure it fires before other click handlers
        setTimeout(() => {
            document.addEventListener('click', handler, true);
            document.addEventListener('touchstart', handler, true);
        }, 0);
    },

    unmounted(el) {
        // Clean up listeners
        document.removeEventListener('click', el.__clickOutsideHandler__, true);
        document.removeEventListener('touchstart', el.__clickOutsideHandler__, true);
        delete el.__clickOutsideHandler__;
    }
};